import React from 'react'
import { useParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { convertTo12HourFormat } from '../../util/format-data';
import { 
  ButtonGroup, 
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography, 
  Textarea,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Spinner,
  IconButton,
  Slider,
  Select, 
  Option,
  Switch
} from "@material-tailwind/react";

import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { getAllBrc20AdminList, checkBrc20Password, updateBrc20Password, registerBrc20AdminData } from '../../util/brc20-api';

export default function Brc20PresaleAdmin() {
  const { param } = useParams();

  const divRef = useRef(null);
  const { t, i18n } = useTranslation();

  const [flag, setFlag] = useState(0);
  const [oldPassword, setOldPassword] = useState("");
  const [old1Password, setOld1Password] = useState("");
  const [updatedPassword, setUpdatedPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [receiveAddress, setReceiveAddress] = useState("");
  const [minAmount, setMinAmount] = useState(0);
  const [ticker, setTicker] = useState("");
  const [passwordValid, setPasswordValid] = useState(0);
  const [startMonth, setStartMonth] = useState(0);
  const [startDate, setStartDate] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [endMonth, setEndMonth] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [description, setDescription] = useState("");

  const months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  const dates = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'];
  const times = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];


  useEffect(() => {
    getPATokenAdmin();
  }, [])

  const getPATokenAdmin = async () => {
    const results = await getAllBrc20AdminList(param);
    if (results.data.length == 0) {
      setFlag(0);
    } else {
      setFlag(1);
      setReceiveAddress(results.data[0].receiveAddress);
      setDescription(results.data[0].description);
      let tempStartTime = results.data[0].startTime;
      setStartMonth('' + parseInt(tempStartTime.split('-')[1]));
      setStartDate('' + parseInt(tempStartTime.split('-')[2]));
      setStartTime('' + parseInt(tempStartTime.split('-')[3]));

      let tempEndTime = results.data[0].endTime;
      setEndMonth('' + parseInt(tempEndTime.split('-')[1]));
      setEndDate('' + parseInt(tempEndTime.split('-')[2]));
      setEndTime('' + parseInt(tempEndTime.split('-')[3]));
      setMinAmount(results.data[0].minAmount / Math.pow(10, 8));
      setTicker(ticker);
    }
  }

//   const getWhitelistAddresses = async () => {
//     if (divRef.current) {
//       let datas = await getPATokenWhitelistAddresses(number);
//       let result = "";
//       for(let data of datas.data) {
//         result = result + "<div>" + data.address + ",</div>";
//       }
//       console.log(result);
//       divRef.current.innerHTML = result;
//     }
//   }

  const handleLogin = async () => {
    let results = await checkBrc20Password(oldPassword, param);
    if (results.status == "success") {
      setPasswordValid(1);
    }
    else {
      setPasswordValid(0);
      toast.error(t('Password Is Incorrect'));
    }
  }

  const handleStatus = () => {
    setStatus(!status);
  }

  const handleWhitelist = () => {
    setWhitelist(!whitelist);
  }

  const handleSave = async () => {
    if (receiveAddress == "") {
      toast.error(t('Insert Payment Receiver Address Error Message'));
      return;
    }
   
    let params = {
      ticker: param,
      receiveAddress: receiveAddress,
      startTime: '2025' + '-' + startMonth.padStart(2, '0') + '-' + startDate.padStart(2, '0') + '-' + startTime.padStart(2, '0'),
      endTime: '2025' + '-' + endMonth.padStart(2, '0') + '-' + endDate.padStart(2, '0') + '-' + endTime.padStart(2, '0'),
      minAmount: parseFloat(minAmount) * Math.pow(10, 8),
      password: oldPassword,
      description: description
    }
    
    await registerBrc20AdminData(params);

    // if (whitelist == true) {
    //   let addresses = handleWhiteListAddresses();
    //   params = {
    //     number: number,
    //     addresses: addresses,
    //     passwordKey: oldPassword,
    //     ticker: param
    //   }

    //   await savePATokenWhitelistAddresses(params);
    // }

    toast.success(t('Successfully Updated'));
  }

  const handlePassword = async () => {
    if (updatedPassword != confirmPassword) {
      toast.error(t('Password Does Not Match Error Message'));
      return;
    }
    let results = await updateBrc20Password(old1Password, updatedPassword, param);
    if (results.status == "success") {
      toast.success(t('Successfully Updated'));
    }
    else {
      toast.error(t('Password Is Incorrect'));
    }
  }

  const handleWhiteListAddresses = () => {
    if (divRef.current) {
      const content = divRef.current.innerHTML;
      const cleanedContent = content.replace(/<\/?div>/g, '').replace(/\s+/g, '');
      const results = cleanedContent.split(',');
      const temp = results.filter(data => data != "");
      return temp;
    }
  }

  const handleStartMonth = (value) => {
    setStartMonth(value);
  }

  const handleStartDate = (value) => {
    setStartDate(value);
  }

  const handleStartTime = (value) => {
    setStartTime(value);
  }

  const handleEndMonth = (value) => {
    setEndMonth(value);
  }

  const handleEndDate = (value) => {
    setEndDate(value);
  }

  const handleEndTime = (value) => {
    setEndTime(value);
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-start items-center mb-10 min-h-[600px]">
      {
        flag == 0 ? 
        <div className="mt-10 text-gray-800 font-bold text-[32px]">
          {t('No Available Token')}.
        </div>
        :
        <div className="mt-10 flex flex-col gap-3 items-center">
          <div className="text-primary text-[32px] font-bold text-center">{ param.toUpperCase() }</div>
          {
            passwordValid == 0 ? 
            <div className="flex flex-col gap-8 mt-10 items-center bg-gray-900 p-8 rounded-md">
              <div className="sm:w-[400px] w-[320px]">
                <Input label={t('Insert Password')} type="password" color="white" value={oldPassword} onChange={(e) => { setOldPassword(e.target.value)}}/>
              </div>
              <div className="px-10 py-2 bg-primary text-white rounded-md font-bold cursor-pointer" onClick={handleLogin}>{t('LOGIN')}</div>
            </div>
            :
            <>
              <div className="flex flex-col gap-5 mt-10 bg-gray-900 p-5 rounded-md w-full items-center">
                <div className="sm:w-[400px] w-[320px]">
                  <Input label={t('Insert Old Password')} type="password" color="white" value={old1Password} onChange={(e) => { setOld1Password(e.target.value)}}/>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <Input label={t('Insert New Password')} type="password" color="white" value={updatedPassword} onChange={(e) => { setUpdatedPassword(e.target.value)}}/>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <Input label={t('Confirm New Password')} type="password" color="white" value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value)}}/>
                </div>
                <div className="flex flex-row justify-center">  
                  <div className="w-[300px] px-10 py-2 bg-primary text-white rounded-md font-bold cursor-pointer text-center" onClick={handlePassword}>
                  {t('Change Password')}</div>
                </div>
              </div>
              <div className="flex flex-col gap-5 mt-10 bg-gray-900 p-5 rounded-md w-full items-center">
                <div className="sm:w-[400px] w-[320px]">
                  <Input label={t('Payment Receiver Address')} type="text" color="white" value={receiveAddress} onChange={(e) => { setReceiveAddress(e.target.value)}}/>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <Input label={t('Min Amount Label')} type="text" color="white" value={minAmount} onChange={(e) => { setMinAmount(e.target.value)}}/>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <Textarea label={t('Description')} className="w-full text-white border-white" rows="8" value={description} onChange={(e) => setDescription(e.target.value)}/>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <div className="font-bold text-[18px]">{t('Select Start Time')}:</div>
                  <div className="w-full flex flex-row justify-end">
                    <div className="flex flex-col gap-2 w-[280px]">
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold">Month: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={startMonth}
                          onChange={handleStartMonth}
                        >
                          {
                            months.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{data}</Option>
                            )
                          }
                        </Select>
                      </div>
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold mr-[12px]">Date: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={startDate}
                          onChange={handleStartDate}
                        >
                          {
                            dates.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{data}</Option>
                            )
                          }
                        </Select>
                      </div>
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold mr-[12px]">Time: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={startTime}
                          onChange={handleStartTime}
                        >
                          {
                            times.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{convertTo12HourFormat(parseInt(data))}</Option>
                            )
                          }
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sm:w-[400px] w-[320px]">
                  <div className="font-bold text-[18px]">{t('Select End Time')}:</div>
                  <div className="w-full flex flex-row justify-end">
                    <div className="flex flex-col gap-2 w-[280px]">
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold">Month: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={endMonth}
                          onChange={handleEndMonth}
                        >
                          {
                            months.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{data}</Option>
                            )
                          }
                        </Select>
                      </div>
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold mr-[12px]">Date: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={endDate}
                          onChange={handleEndDate}
                        >
                          {
                            dates.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{data}</Option>
                            )
                          }
                        </Select>
                      </div>
                      <div className="flex flex-row items-end gap-6">
                        <div className="text-white font-bold mr-[12px]">Time: </div>
                        <Select 
                          variant="static" 
                          className="text-white"
                          value={endTime}
                          onChange={handleEndTime}
                        >
                          {
                            times.map((data) => 
                              <Option value = {data} key={uuidv4()} className="font-bold">{convertTo12HourFormat(parseInt(data))}</Option>
                            )
                          }
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="sm:w-[400px] w-[320px] flex flex-row gap-3 items-center">
                  <div className="text-white font-bold text-[18px] mr-10 sm:w-[240px] w-[160px]">{t('Mint Status')}</div>
                  <Switch color="red" checked = {status} onChange={handleStatus}/>
                </div>
                <div className="sm:w-[400px] w-[320px] flex flex-row gap-3 items-center">
                  <div className="text-white font-bold text-[18px] mr-10 sm:w-[240px] w-[160px]">{t('WL Addresses OFF ALL')}</div>
                  <Switch color="red" checked = {whitelist} onChange={handleWhitelist}/>
                </div>

                {
                  whitelist ? 
                  <>
                    <div className="flex flex-row justify-end">
                      <div className="px-4 py-1 bg-primary rounded-md cursor-pointer" onClick={getWhitelistAddresses}>{t('Refresh')}</div>
                    </div>
                    <div 
                      ref={divRef}
                      className="w-full sm:max-w-[400px] max-w-[320px] border-[1px] border-solid border-white h-[200px] rounded-md p-2 overflow-auto" 
                      contentEditable= "true">
                      
                    </div>
                  </>
                  :
                  <>
                  </>
                } */}

                <div className="flex flex-row justify-center">  
                  <div className="w-[200px] px-10 py-2 bg-primary text-white rounded-md font-bold cursor-pointer text-center" onClick={handleSave}>{t('SAVE')}</div>
                </div>
              </div>
            </>
          }
        </div>
      }
    </div>
  )
}
